// menu-items/index.js
import { useState, useEffect } from 'react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import * as AntdIcons from '@ant-design/icons';

const API_URL = process.env.REACT_APP_LIVE_API_URL;

const fetchMenuData = async (menuType) => {
  const TOKEN = localStorage.getItem('serviceToken');
  const user = JSON.parse(localStorage.getItem('user'));

  if (!user) return null;

  // const product = window.location.pathname.split('/')[1].toUpperCase();
  const product = window.location.pathname.split('/')[2]?.toUpperCase() || 'OMS';
  const data = {
    product: product,
    moduleId: menuType,
    organizationType: user.organizationType || '',
    userType: user.userType || ''
  };

  try {
    const response = await axios({
      method: 'post',
      url: `${API_URL}common_setup/fetch_side_menu`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TOKEN}`
      },
      data
    });

    return response.data.data;
  } catch (error) {
    console.error(`Error fetching ${menuType} menu:`, error);
    return null;
  }
};

const transformMenuData = (apiData, menuType) => {
  if (!apiData) return require(`./${menuType}`).default;

  const menuItem = {
    id: apiData.id,
    title: <FormattedMessage id={apiData.title} defaultMessage={apiData.title} />,
    type: apiData.type,
    ...(apiData.icon && { icon: AntdIcons[apiData.icon] }),
    ...(apiData.url && { url: apiData.url }),
    children: []
  };

  if (apiData.children) {
    apiData.children.forEach((child) => {
      const childItem = {
        id: child.id,
        title: <FormattedMessage id={child.title} defaultMessage={child.title} />,
        type: child.type,
        ...(child.icon && { icon: AntdIcons[child.icon] }),
        ...(child.url && { url: child.url })
      };

      if (child.children) {
        childItem.children = child.children.map((grandChild) => ({
          id: grandChild.id,
          title: <FormattedMessage id={grandChild.title} defaultMessage={grandChild.title} />,
          type: grandChild.type,
          ...(grandChild.icon && { icon: AntdIcons[grandChild.icon] }),
          ...(grandChild.url && { url: grandChild.url })
        }));
      }

      menuItem.children.push(childItem);
    });
  }

  return menuItem;
};

export const useMenuItems = () => {
  const [menuItems, setMenuItems] = useState({ items: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // const product = window.location.pathname.split('/')[1].toUpperCase();
  const product = window.location.pathname.split('/')[2]?.toUpperCase() || 'OMS';

  useEffect(() => {
    const loadAllMenus = async () => {
      try {
        const menuTypes =
          product === 'oms'
            ? ['home', 'transactions', 'reports', 'master', 'general']
            : ['home', 'transactions', 'reports', 'master', 'setups', 'general'];

        const menuPromises = menuTypes.map((type) => fetchMenuData(type));
        const apiResults = await Promise.all(menuPromises);

        const transformedMenus = menuTypes
          .map((type, index) => {
            const apiData = apiResults[index];
            return apiData ? transformMenuData(apiData, type) : null;
          })
          .filter(Boolean);

        if (transformedMenus.length > 0) {
          setMenuItems({
            items: transformedMenus
          });
        } else {
          console.warn('No valid menus were loaded from API');
        }
      } catch (err) {
        console.error('Failed to load menus:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadAllMenus();
  }, [product]);

  return { menuItems, loading, error };
};
